import React, { useEffect, useState, useRef } from 'react';
import toast from 'react-hot-toast';
import { withRouter } from 'react-router-dom';
import { isMobile } from '../../utils'
import moment from 'moment';
import {
    Grid,
    Typography,
    IconButton,
    Drawer,
    Button,
    Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import Routes from '../../routes';
import {
    PageTitleWithToolTip,
    PrimaryButton,
    SecondaryButton,
    LoadingBar,
    LoadingButton,
    BreadCrumbs,
    Stepper,
    ExitConfirmationModal,
    CommonModal,
    CommonModal as CreationSuccessModal,
    CommonModal as SaveForLaterModal,
    CheckBox,
    Error404,
} from '../Common';
import Enums from '../../enums';
import {
    allServiceEventSteps,
    filterTechniciansForService,
    serviceEventTypesRequiredFields,
    initialServiceEventsState,
    initialRequiredFieldsMissing,
    initialVitalStatState,
    badValuesArray,
    reverseServiceEventEnums,
    getLaborDropdownValues,
    getTotalGasAmount,
    enabledServiceEventTypes,
    formatFinalData,
    determineServiceOptions,
    shouldFetchCylinders,
    initialDropdownOptions,
    unknownCylinder,
    getFormattedDate,
    getInitialErrorsExist,
    repairDetailsAddRequiredFields,
    repairNotesAddRequiredFields,
    initialVerificationTestAddRequiredFields,
    followUpVerificationServiceAddRequiredFields,
} from './utils';
import { trakrefFontFamily, postRequestHeaders } from '../../utils';
import {
    trakrefBlue,
    Grey1,
    Grey3,
    Grey6,
    Black,
    chromeDividerColor,
    chromeInfoBackground,
    chromeMutedTextColor,
    inactiveStatusColor,
} from '../../color_utils';
import {
    Completion,
    GasTransaction,
    VerificationTests,
    EnterService,
    RepairDetails,
    InitialVertificationTest,
    NewSystemDetails,
    RepairNotes,
    FollowUpVerificationTest,
    PostShutDownStatus,
    LaborHours,
    ProblemResolution,
    RecordVitalStats,
} from './CreationSteps';
import Rocket from '../../Icons/img-rocket_launch.svg';
import { hotjar } from 'react-hotjar';
import UserInfo from '../../UserInfo';
import { useIntl } from 'react-intl';
import { TranslateW, Translate } from "../../Utils/Languages/Translate";
import { TranslateArray } from "../../Utils/Languages/TranslateDropdown";
import { renderWeight } from '../../Utils/weight_utils';
import useNavigate from '../../hooks/useNavigate';
import useBreadCrumbs from '../../hooks/useBreadCrumbs';
import useFormDirty from "../../hooks/useFormDirty";
const mobileBreakpoints = { display: { xs: 'none', md: 'block' } };
const fieldsChangeTrackingDisabled = [
    'assetDetails',
    'workItemTypeString',
    'coolingApplianceStatusId', 
    'exitModalOpen',
    'workOrderId',
    'laborTimeMinutes',
    'maxViewedStepIndex',
];

// Normalize wizard steps from older records/drafts:
// - Convert legacy gas step ids ("RecoverGas" / "InstallGas") to "GasTransaction"
// - Remove duplicates so the wizard can never show split gas pages again
const normalizeLegacyGasSteps = (steps = []) => {
    const seenIds = new Set();
    const normalizedSteps = [];

    steps.forEach((step) => {
        const stepId = step?.props?.id;
        const normalizedStepId = (
            stepId === 'RecoverGas' || stepId === 'InstallGas'
                ? 'GasTransaction'
                : stepId
        );

        if (!normalizedStepId || seenIds.has(normalizedStepId)) return;
        seenIds.add(normalizedStepId);
        normalizedSteps.push(normalizedStepId === stepId ? step : Translate(normalizedStepId));
    });

    return normalizedSteps;
};

const AddOrEditServiceEvent = ({
    match: {
        params: {
            workOrderId = '',
            serviceEventId = '',
        } = {}
    } = {},
    history = {},
    history: {
        push = () => { },
        location: {
            state = {}
        } = {},
    } = {},
    isEditing = false,
}) => {
    const intl = useIntl();
    const requiredFieldsRef = useRef(null);
    const [warning, setWarning] = useState(false);
    const [loading, setLoading] = useState(true);
    const [hasError404, setHasError404] = useState(false);
    const [loading2, setLoading2] = useState(true);
    const [workOrderID, setWorkOrderID] = useState(workOrderId);
    const [workOrderState, setWorkOrderState] = useState(null);
    const [dropdownOptions, setDropdownOptions] = useState(initialDropdownOptions);
    const [serviceEventSteps, setServiceEventSteps] = useState([Translate("EnterService")]);
    const [serviceEventStepErrors, setServiceEventStepErrors] = useState([]);
    const [skippedStepIds, setSkippedStepIds] = useState([]);
    const [requiredFields, setRequiredFields] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const gasTransactionDirtyRef = useRef(false);
    const [discardGasModalOpen, setDiscardGasModalOpen] = useState(false);
    const [pendingStepIndex, setPendingStepIndex] = useState(null);
    const [formState, setFormState] = useState(initialServiceEventsState);
    const [requiredFieldsMissing, setRequiredFieldsMissing] = useState(initialRequiredFieldsMissing);
    const [fieldsWithErrors, setFieldsWithErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [vitalStatsOpen, setVitalStatsOpen] = useState(false);
    const [vitalStatData, setVitalStatData] = useState(initialVitalStatState);
    const [recentLeaksData, setRecentLeaksData] = useState({ leaks: [], totalCount: 0, loading: false });
    const [newServiceEventId, setNewServiceEventId] = useState("");
    const isRetroFit = formState.workItemTypeId === Enums.SE.WorkItemType.Retrofit;
    const oldRequiredFields = serviceEventTypesRequiredFields[formState.workItemTypeId];
    const pageHeader = isEditing ? Translate("EditServiceEvent", { id: serviceEventId }) : TranslateW("createServiceEvent");
    const userOnFirstStep = serviceEventSteps[activeStep].props.id === "EnterService";
    const renderSaveForLaterModal = (
        !formState.saveForLaterModalOpen
        && (
            localStorage.getItem("saveForLaterShowAgain") === null
            || localStorage.getItem("saveForLaterShowAgain") === 'true'
        )
    );
    // Count install rows that are still active; soft-deleted rows are enabled:false.
    const enabledInstallCount = (formState.installs || []).filter(x => x.enabled !== false).length;
    // serviceEventSteps items are React elements; gate by props.id (not display label text).
    const noGasInstallationData = (
        serviceEventSteps[activeStep]?.props?.id === 'GasTransaction'
        && enabledInstallCount <= 0
    );
    const gasInstallationRequired = (
        isRetroFit
    );
    // Only enforce new-system capacity once it's a valid positive number
    // (avoids blocking on an unset value).
    const newSystemMaxCapacity = Number(formState.newGasChargeCapacityLbs);
    const newSystemCapacityKnown = Number.isFinite(newSystemMaxCapacity) && newSystemMaxCapacity > 0;
    const nextDisabled = (
        !formState.workItemTypeId
        || (gasInstallationRequired && noGasInstallationData)
        || (
            isRetroFit
            && newSystemCapacityKnown
            && getTotalGasAmount(formState.installs) > newSystemMaxCapacity
        )
    );
    const serviceEventType = formState.workItemTypeId;
    const renderServiceActionField = (
        serviceEventType === Enums.SE.WorkItemType.Retrofit
        || serviceEventType === Enums.SE.WorkItemType.ShutdownMothball
        || serviceEventType === Enums.SE.WorkItemType.Install
        || serviceEventType === Enums.SE.WorkItemType.Reinstall
    );
    const renderSaveForLaterButton = (
        (
            !formState.workItemStatusId
            || formState.workItemStatusId === Enums.WorkItemStatusTypes.Open
        )
        && !saving
    );
    const enterServiceReady = (
        !!formState.assetId
        && !!formState.workItemTypeId
        && !!formState.primaryTechnicianId
        && !!formState.serviceDate
    );
    const finalStep = activeStep === serviceEventSteps.length - 1;
    const shouldRenderStepper = serviceEventSteps.length > 1 && activeStep > 0;
    const serviceEventStepCompleted = serviceEventSteps.map((step, index) => {
        const stepId = step?.props?.id;
        const hasStepValidation = (requiredFieldsRef.current?.[stepId]?.length || 0) > 0;
        return index < activeStep && hasStepValidation && serviceEventStepErrors[index] === false;
    });
    const visibleStepperSteps = serviceEventSteps.slice(1);
    const visibleStepperCompleted = serviceEventStepCompleted.slice(1);
    const visibleActiveStep = Math.max(activeStep - 1, 0);
    const isAdmin = (
        UserInfo.isSystemAdministrator()
        || UserInfo.isSuperTenantAdmin()
        || UserInfo.isTenantAdministrator()
        || UserInfo.isTechnicianManager()
    );

    const { initializeData, isDirty } = useFormDirty();
    const navigate = useNavigate({
        pageName: 'AddOrEditServiceEvent'
    });
    const breadCrumb = useBreadCrumbs({
        path: { id: 'AddOrEditServiceEvent', text: isEditing ? 'Edit' : 'Create Service Event', link: history.location.pathname, shouldBeReplaced: !isEditing }
    });

    useEffect(() => {

        const getWorkOrderID = async (workItemID) => {
            const data = await fetch(Routes.ServiceEvent.GetWorkOrderIdFromWorkItemId(workItemID));
            const workOrderID1 = await data.json();
            setWorkOrderID(workOrderID1);
            return workOrderID1;
        };

        const fetchDropDownData = async (WorkOrderID) => {
            const response = await fetch(Routes.ServiceEvent.AddServiceEventDropdowns(WorkOrderID, serviceEventId));
            let {
                workOrderPhysicalState = '',
                assets = [],
                workItemTypes = [],
                technicians = [],
                leakCauses = [],
                leakDetectionMethods = [],
                leakLocationCategories = [],
                leakLocations = [],
                transferReasons = [],
                coolingApplianceStatuses = [],
                repairStatuses = [],
                repairOutcomeTypes = [],
                materialTypes = [],
                chargeCapacitySourceTypes = [],
                recoveryEquipment = [],
                serviceActions = [],
                glCodes = [],
                locations = [],
                materialStatuses = [],
                recoverGasStatuses = [],
                workOrderNumber = ''
            } = await response.json();

            const laborHours = getLaborDropdownValues();

            setDropdownOptions((prevOptions) => ({
                ...prevOptions,
                assets,
                workItemTypes: TranslateArray(intl, workItemTypes, "WorkItemType"),
                technicians,
                leakCauses: TranslateArray(intl, leakCauses, "LeakCause"),
                leakLocationCategories: TranslateArray(intl, leakLocationCategories, "LeakLocationCategory"),
                leakLocations: TranslateArray(intl, leakLocations, "LeakLocation"),
                leakDetectionMethods: TranslateArray(intl, leakDetectionMethods, "LeakDetectionMethod"),
                glCodes: TranslateArray(intl, glCodes, "GLCodes"),
                locations,
                laborHours,
                repairStatuses: TranslateArray(intl, repairStatuses, "RepairStatus"),
                repairOutcomeTypes: TranslateArray(intl, repairOutcomeTypes, "repairOutcome"),
                transferReasons: TranslateArray(intl, transferReasons, "TransferReason"),
                coolingApplianceStatuses: TranslateArray(intl, coolingApplianceStatuses, "coolingApplianceStatus"),
                materialTypes,
                chargeCapacitySourceTypes: TranslateArray(intl, chargeCapacitySourceTypes, "ChargeCapacitySourceTypes"),
                recoveryEquipment,
                serviceActions: TranslateArray(intl, serviceActions, "ServiceActions"),
                materialStatuses: materialStatuses.filter(ms => (ms.name == 'Virgin' || ms.name == "Unknown" || ms.name == "Reclaim")),
                recoverGasStatuses: recoverGasStatuses
            }));

            setWorkOrderState(workOrderPhysicalState);

            if (localStorage.getItem("isprod") === 'true') {
                const filteredworkItemTypes = workItemTypes.filter(type => enabledServiceEventTypes.includes(type.id));
                setDropdownOptions(prev => ({
                    ...prev,
                    workItemTypes: filteredworkItemTypes,
                    savedWorkItemTypes: filteredworkItemTypes
                }));
            } else {
                setDropdownOptions(prev => ({
                    ...prev,
                    workItemTypes,
                    savedWorkItemTypes: workItemTypes
                }));
            }
            setFormState(prev => ({
                ...prev,
                workOrderId: WorkOrderID,
                workOrderNumber,
            }));
            return { assets, workItemTypes, technicians };
        };

        const fetchServiceEventDetails = async (serviceEventID) => {
            const response = await fetch(Routes.ServiceEvent.DetailsForEditing(serviceEventID));
            if (response.status === 404) {
                setHasError404(true)
                return {
                    assetId: 0, primaryTechnicianId: 0, hasError: true
                }
            }

            if (response.status !== 200) {
                toast.error('Could Not Fetch Service Event Details', { duration: 5000 });
                return {
                    assetId: 0, primaryTechnicianId: 0, hasError: true
                }
            }

            const data = await response.json();


            const {
                assetId,
                primaryTechnicianId,
                workItemTypeId,
                laborTimeMinutes,
                initialLeakInspection = {},
                initialVerificationLeakInspection = {},
                verificationLeakInspection = {},
                installs,
                serviceTransferReasonId,
                subsystemId,
                repairOutcomeTypeId,
            } = data;

            if (shouldFetchCylinders(workItemTypeId) && primaryTechnicianId) {
                await fetchCylindersForAsset(primaryTechnicianId, assetId);
            }

            const serviceEventSteps = [...allServiceEventSteps[workItemTypeId]];
            const mappedServiceEventSteps = serviceEventSteps.map(s => s.props.id); // translations
            const laborTimeValue = getLaborDropdownValues(laborTimeMinutes).id;
            let requiredFields = serviceEventTypesRequiredFields[workItemTypeId];
            console.log('ServiceEvent data', data);

            // Insert FollowUpVerificationService right BEFORE Completion so Completion
            // always stays last. (The old hardcoded index 6 landed after Completion in
            // the unified 6-step layout.)
            if (
                initialVerificationLeakInspection
                && initialVerificationLeakInspection.wasLeakFound === true
                && !mappedServiceEventSteps.includes('FollowUpVerificationService')
            ) {
                const completionIdx = serviceEventSteps.findIndex(s => s.props.id === 'Completion');
                serviceEventSteps.splice(completionIdx === -1 ? serviceEventSteps.length : completionIdx, 0, Translate('FollowUpVerificationService'));
            }

            // Outcome = NoRepairAttempted: clear IVT/FVT required fields so user can proceed (story #14715).
            // Strict === keeps null (pre-refactor records) on the legacy wasLeakFound path above.
            if (repairOutcomeTypeId === Enums.SE.RepairOutcomeType.NoRepairAttempted) {
                requiredFields = {
                    ...requiredFields,
                    InitialVerificationTest: [],
                    FollowUpVerificationService: [],
                };
            }

            // Skip the gas transfer step when WasGasTransferred = false (Service/Leak Repair only).
            // NULL (pre-refactor records) counts as Yes, so the step stays visible. The step is
            // kept in the navigator with a skipped visual state rather than removed.
            if (
                workItemTypeId === Enums.SE.WorkItemType.ServiceOrLeakRepair
                && data.wasGasTransferred === false
            ) {
                setSkippedStepIds(prev =>
                    prev.includes('GasTransaction') ? prev : [...prev, 'GasTransaction']
                );
            } else {
                setSkippedStepIds(prev => prev.filter(id => id !== 'GasTransaction'));
            }

            // RepairDetails - leak found - append additional required fields
            if (initialLeakInspection.wasLeakFound && workItemTypeId === Enums.SE.WorkItemType.ServiceOrLeakRepair) {
                requiredFields = repairDetailsAddRequiredFields(requiredFields);
                requiredFields = repairNotesAddRequiredFields(requiredFields);
            }

            // InitialVerificationTest - no leak found - append additional required field (inspectionDate)
            if (initialVerificationLeakInspection.wasLeakFound === false) {
                requiredFields = initialVerificationTestAddRequiredFields(requiredFields);
            }

            // FollowUpVerificationService - leak found - append additional required fields
            if (verificationLeakInspection.wasLeakFound) {
                requiredFields = followUpVerificationServiceAddRequiredFields(
                    requiredFields,
                    initialLeakInspection,
                    initialVerificationLeakInspection
                );
            }

            if (
                initialLeakInspection.wasLeakFound === true
                && initialVerificationLeakInspection.wasLeakFound === true
                && !requiredFields["FollowUpVerificationService"].includes("leakRepairDispositionTypeId")
            ) {
                requiredFields["FollowUpVerificationService"].push("leakRepairDispositionTypeId");
            }

            // Gas Transaction - install gas has transfers - purpose for adding is empty
            if (installs && installs.length > 0 && !serviceTransferReasonId) {
                requiredFields = {
                    ...requiredFields,
                    "GasTransaction": ["serviceTransferReasonId"]
                };
            }

            requiredFieldsRef.current = requiredFields;
            setRequiredFields(requiredFields);
            setServiceEventSteps(normalizeLegacyGasSteps(serviceEventSteps));
            setFormState(prev => ({
                ...prev,
                ...data,
                wasGasTransferred: data.wasGasTransferred ?? true,
                laborTimeMinutes: laborTimeValue,
                workItemTypeString: reverseServiceEventEnums[workItemTypeId],
                maxViewedStepIndex: serviceEventSteps.length - 1,
            }));

            // Set original copy of data before any changes are made 
            initializeData(
                { ...initialServiceEventsState, ...data },
                fieldsChangeTrackingDisabled
            );

            return { assetId, primaryTechnicianId, subsystemId, hasError: false };
        };

        if (workOrderId && !isEditing) {
            if (state.serviceEventData) {
                const { assetId, primaryTechnicianId, workItemTypeId } = state.serviceEventData;
                const getAllData = async () => {
                    const {
                        assets: assetList,
                        workItemTypes,
                        technicians: technicianList
                    } = await fetchDropDownData(workOrderID);
                    await handleAssetSelect({
                        assetId,
                        assetList,
                        workItemTypes,
                        technicianList,
                        primaryTechId: primaryTechnicianId
                    });
                };
                getAllData();
                handleExistingFields(state.serviceEventData);
                changeServiceType(workItemTypeId);
            } else {
                fetchDropDownData(workOrderId);
            }
        }

        if (serviceEventId && isEditing) {
            const getAllData = async () => {
                

                const workOrderID = await getWorkOrderID(serviceEventId);
                const {
                    assets: assetList,
                    workItemTypes,
                    technicians: technicianList
                } = await fetchDropDownData(workOrderID);
                const { assetId, primaryTechnicianId, subsystemId, hasError } = await fetchServiceEventDetails(serviceEventId);
                if (hasError) {
                    setLoading2(false);
                    return;
                }
                await handleAssetSelect({ assetId, assetList, workItemTypes, technicianList, primaryTechnicianId, subsystemId });
                setLoading2(false);
            };
            getAllData();
        }

        setLoading(false);
        setLoading2(false);
    }, []);

    useEffect(() => {
        if (isEditing && loading === false) {
            const {
                missingFieldsObject,
                stepsWithErrors,
                fieldsWithBadData
            } = validateAllSteps({});
            setServiceEventStepErrors(stepsWithErrors);
            setRequiredFieldsMissing(missingFieldsObject);
            setFieldsWithErrors(fieldsWithBadData);
        }

    }, [loading2]);

    const handleExistingFields = (exisitingServiceEventData) => {
        const keys = Object.keys(exisitingServiceEventData);
        return keys.forEach(key => setGlobalState(key, exisitingServiceEventData[key]));
    };

    const fetchAfterServiceStatusOptions = async (selectedAssetStatusID) => {
        const URL = Routes.Asset.FetchAfterServiceStatusOptions(selectedAssetStatusID);
        const fetchAfterServiceOptions = async () => {
            const options = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            };
            fetch(URL, options)
                .then(async (response) => {
                    const statusOptions = await Promise.resolve(response.json());
                    setDropdownOptions(prev => ({
                        ...prev,
                        afterServiceStatusOptions: statusOptions
                    }));
                })
                .catch(error => console.log('Error fetching after service status options', error));
        };

        await fetchAfterServiceOptions();
    };

    const fetchCylindersForAsset = async (primaryTechID, assetId) => {
        const recoverURL = Routes.Asset.FetchRecoveryCylinders(assetId, primaryTechID);
        const installURL = Routes.Asset.FetchInstallCylinders(assetId, primaryTechID);
        const fetchOptions = { method: 'POST', headers: { ...postRequestHeaders } };

        const fetchCylinders = async (url, isInstall) => {
            fetch(url, fetchOptions)
                .then(async (response) => {
                    const cylinders = await Promise.resolve(response.json());
                    if (isInstall) {
                        return setDropdownOptions(prev => ({
                            ...prev,
                            installCylinders: [...unknownCylinder, ...cylinders]
                        }));
                    }

                    return setDropdownOptions(prev => ({
                        ...prev,
                        recoveryCylinders: [...unknownCylinder, ...cylinders]
                    }));
                })
                .catch(error => console.log('Error fetching recovery Cylinder list', error));
        };

        await fetchCylinders(recoverURL, false);
        await fetchCylinders(installURL, true);
    };

    const saveServiceEvent = async (saveType = "") => {
        const { workItemTypeId } = formState;
        const type = !saveType ? "complete" : saveType; // complete or saveForLater
        let success = true;

        const final_data = formatFinalData(
            workItemTypeId,
            { ...formState, ServiceEventCreationType: type }
        );

        const submitData = async () => {
            const response = await fetch(Routes.ServiceEvent.AddServiceEvent(), {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(final_data)
            });
            const data = await response.json();
            const id = data;
            console.log(data);

            if (response.status === 200) {
                return id;
            }

            toast.error('There was an error creating the Service Event', { duration: 6000 });
            success = false;
            if (data.length > 0) {
                data.forEach(i => toast.error(i.exceptionMessage), { duration: 6000 });
            }

            return 0;
        };

        console.log('state data at time of submit function call', final_data);

        const newServiceEventID = await submitData();
        return { newServiceEventID, success };

        // FOR TESTING PURPOSES
        /* success = false;
        const testerID = 0;
        return { testerID, success }; */
    };

    const clearTypeOfService = () => {
        delete formState.workItemTypeId;
        delete formState.primaryTechnicianId;
        delete formState.secondaryTechnicianId;
        delete formState.serviceDate;
        return setServiceEventSteps([Translate("EnterService")]);
    };

    const changeServiceType = (typeID) => {
        if (!typeID) return clearTypeOfService();
        const newServiceTypeID = parseInt(typeID);
        const newServiceEventSteps = allServiceEventSteps[newServiceTypeID];
        const requiredFields = serviceEventTypesRequiredFields[newServiceTypeID];
        const serviceEventStepErrors = new Array(newServiceEventSteps.length).fill(false);

        if (
            newServiceTypeID === Enums.SE.WorkItemType.Retrofit
            && !badValuesArray.includes(formState.assetId)
        ) {
            // Not sure, coming back to this one
            // setFormState(prev => ({ ...prev, newMaterialTypeId: formState.assetMaterialTypeId }));
            const materialTypeExists = dropdownOptions.materialTypes.some(mt => mt.id === formState.assetMaterialTypeId);
            if (materialTypeExists) {
                setGlobalState("newMaterialTypeId", formState.assetMaterialTypeId);
            }
        }

        setFormState(prev => ({
            ...prev,
            workItemTypeId: typeID,
            workItemTypeString: reverseServiceEventEnums[typeID]
        }));
        requiredFieldsRef.current = requiredFields;
        setRequiredFields(requiredFields);
        if (
            newServiceTypeID === Enums.SE.WorkItemType.LeakInspection
            || newServiceTypeID === Enums.SE.WorkItemType.LeakInspection2
        ) {
            setWarning(true);
        }
        if (newServiceTypeID === Enums.SE.WorkItemType.RecordRefrigerant) {
            setFormState(prev => ({ ...prev, finalCoolingApplianceStatusId: 1 })); // Normal Operation
        }
        setServiceEventStepErrors(serviceEventStepErrors);
        return setServiceEventSteps(normalizeLegacyGasSteps(newServiceEventSteps));
    };

    const setGlobalState = (mainKey, value, nestedValue = false) => {
        if (nestedValue) {
            const [key, nestedKey] = mainKey.split(".");
            return setFormState((prevState) => ({
                ...prevState,
                [key]: {
                    ...prevState[key],
                    [nestedKey]: value,
                }
            }));
        }
        // console.log('mainKey', mainKey);
        // console.log('value', value);
        return setFormState((prevState) => ({
            ...prevState,
            [mainKey]: value,
        }));
    };

    const setVitalStatState = (new_vital_stat_data) => (
        setVitalStatData(vitalStatData => ({
            ...vitalStatData,
            ...new_vital_stat_data
        }))
    );

    const getRequiredFieldsMissing = (requiredFieldsArray, nestedObjectKey = "") => {
        const nestedObjectExists = !!nestedObjectKey;
        let errorObj = {};

        if (nestedObjectExists) {
            errorObj = { [nestedObjectKey]: {} };
        }

        requiredFieldsArray.forEach((field) => {
            let emptyField = badValuesArray.includes(formState[`${field}`]);

            if (nestedObjectExists) {
                emptyField = badValuesArray.includes(formState[`${nestedObjectKey}`][`${field}`]);
            }

            if (emptyField) {
                if (!nestedObjectExists) {
                    errorObj[`${field}`] = true;
                } else {
                    errorObj[`${nestedObjectKey}`][`${field}`] = true;
                }
            }

            if (!emptyField) {
                if (!nestedObjectExists) {
                    errorObj[`${field}`] = false;
                } else {
                    errorObj[`${nestedObjectKey}`][`${field}`] = false;
                }
            }
        });
        return errorObj;
    };

    const validateEnterService = (isSavingForLater = false) => {
        const {
            serviceDate,
            selectedAsset: { installDate, disbursementDate }
        } = formState;
        const formattedInstallDate = getFormattedDate(installDate);
        const formattedDisbursementDate = getFormattedDate(disbursementDate);
        const invalidFields = { serviceDate: {} };
        let requiredFieldsArray = requiredFieldsRef.current["EnterService"];

        // ServiceDate no longer required to save ServiceEvent as draft (SaveForLater)
        if (isSavingForLater) {
            requiredFieldsArray = requiredFieldsArray.filter(field => field !== "serviceDate");
        }
        
        const missingFields = getRequiredFieldsMissing(requiredFieldsArray);
        let errorsExist = getInitialErrorsExist({ missingFields, requiredFieldsArray });

        if (installDate && moment(serviceDate).isBefore(installDate, 'day')) {
            invalidFields.serviceDate = {
                errorExists: true,
                helperText: `Service Date Cannot Be Before Install Date (${formattedInstallDate})`
            };
            errorsExist = true;
        }

        if (
            moment(serviceDate).isAfter(disbursementDate, 'day')
            && ![
                Enums.SE.WorkItemType.Reinstall,
                Enums.SE.WorkItemType.Move
            ].includes(formState.workItemTypeId)
        ) {
            invalidFields.serviceDate = {
                errorExists: true,
                helperText: `Service Date Cannot Be After Current Date (${formattedDisbursementDate})`
            };
            errorsExist = true;
        }

        return { errorsExist, invalidFields, missingFields };
    };

    const validateRepairDetails = () => {
        const {
            serviceDate,
            initialLeakInspection: { inspectionDate: repairDetailsDateLeakFound },
            selectedAsset: { installDate }
        } = formState;
        const isMaintenanceNoGas = serviceEventType === Enums.SE.WorkItemType.MaintenanceNoGas;
        const formattedServiceDate = getFormattedDate(serviceDate);
        const formattedInstallDate = getFormattedDate(installDate);
        const invalidFields = { dateLeakFound: {} };
        const nestedKey = isMaintenanceNoGas ? "maintenanceNoGas" : "initialLeakInspection";
        let requiredFieldsArrayKey = isMaintenanceNoGas ? "ProblemResolution" : "RepairDetails";
        requiredFieldsArrayKey = serviceEventType === Enums.SE.WorkItemType.RecordRefrigerant ? "RepairDetails" : requiredFieldsArrayKey;

        const requiredFieldsArray = requiredFieldsRef.current[requiredFieldsArrayKey];
        // Handle `repairOutcomeTypeId` separately because it lives at the top level;
        // all other required fields are checked inside `nestedKey`.
        const repairOutcomeField = "repairOutcomeTypeId";
        const nestedRequiredFields = requiredFieldsArray.filter(field => field !== repairOutcomeField);
        const topLevelMissingFields = getRequiredFieldsMissing(
            requiredFieldsArray.includes(repairOutcomeField) ? [repairOutcomeField] : []
        );

        const nestedMissingFields = getRequiredFieldsMissing(nestedRequiredFields, nestedKey);
        const missingFields = {
            ...nestedMissingFields,
            ...topLevelMissingFields,
        };

        let errorsExist = (
            getInitialErrorsExist({ missingFields: nestedMissingFields, requiredFieldsArray: nestedRequiredFields, nestedKey })
            || getInitialErrorsExist({
                missingFields: topLevelMissingFields,
                requiredFieldsArray: requiredFieldsArray.includes(repairOutcomeField) ? [repairOutcomeField] : []
            })
        );

        if (
            serviceDate
            && repairDetailsDateLeakFound
            && moment(repairDetailsDateLeakFound).isAfter(serviceDate, 'day')
        ) {
            invalidFields.dateLeakFound = {
                errorExists: true,
                helperText: `Date must be on or before Service Date (${formattedServiceDate})`
            };
            errorsExist = true;
        }

        if (
            repairDetailsDateLeakFound
            && installDate
            && moment(repairDetailsDateLeakFound).isBefore(installDate, 'day')
        ) {
            invalidFields.dateLeakFound = {
                errorExists: true,
                helperText: `Date must be on or after asset Install Date (${formattedInstallDate})`
            };
            errorsExist = true;
        }

        return { errorsExist, invalidFields, missingFields };
    };

    const validateRepairNotes = () => {
        const { repairNotes, serviceActionId } = formState;
        const invalidFields = { repairNotes: false, serviceActionId: null };
        const requiredFieldsArray = requiredFieldsRef.current["RepairNotes"];
        const repairOutcomeField = "repairOutcomeTypeId";
        const repairNotesFields = requiredFieldsArray.filter(field => field !== repairOutcomeField);
        const topLevelMissingFields = getRequiredFieldsMissing(
            requiredFieldsArray.includes(repairOutcomeField) ? [repairOutcomeField] : []
        );
        const notesMissingFields = getRequiredFieldsMissing(repairNotesFields);
        const missingFields = {
            ...notesMissingFields,
            ...topLevelMissingFields,
        };
        let errorsExist = (
            getInitialErrorsExist({ missingFields: notesMissingFields, requiredFieldsArray: repairNotesFields })
            || getInitialErrorsExist({
                missingFields: topLevelMissingFields,
                requiredFieldsArray: requiredFieldsArray.includes(repairOutcomeField) ? [repairOutcomeField] : []
            })
        );

        if (!repairNotes) {
            invalidFields.repairNotes = true;
        }

        if (!serviceActionId) {
            invalidFields.serviceActionId = true;
        }

        return { errorsExist, invalidFields, missingFields };
    };

    const validateInitialVerificationTest = () => {
        // No Repair Attempted (#14715): the Initial Verification Test is not applicable,
        // so it has no required/invalid fields. Mirrors the edit-load clearing above so
        // create-mode submit + the Completion review page treat it as complete.
        if (formState.repairOutcomeTypeId === Enums.SE.RepairOutcomeType.NoRepairAttempted) {
            return { errorsExist: false, invalidFields: {}, missingFields: {} };
        }
        const {
            serviceDate,
            initialVerificationLeakInspection: { inspectionDate: repairDate }
        } = formState;
        const formattedServiceDate = getFormattedDate(serviceDate);
        const invalidFields = { repairDate: {} };
        const nestedKey = "initialVerificationLeakInspection";
        const requiredFieldsArray = requiredFieldsRef.current["InitialVerificationTest"];
        const missingFields = getRequiredFieldsMissing(requiredFieldsArray, nestedKey);
        let errorsExist = getInitialErrorsExist({ missingFields, requiredFieldsArray, nestedKey });

        if (
            serviceDate
            && repairDate
            && !moment(repairDate).isSame(serviceDate, 'day')
        ) {
            invalidFields.repairDate = {
                errorExists: true,
                helperText: `Repair Date must be on the Service Date (${formattedServiceDate})`
            };
            errorsExist = true;
        }

        return { errorsExist, invalidFields, missingFields };
    };

    const validateFollowUpVerificationService = () => {
        // No Repair Attempted (#14715): Follow Up Verification is not applicable.
        if (formState.repairOutcomeTypeId === Enums.SE.RepairOutcomeType.NoRepairAttempted) {
            return { errorsExist: false, invalidFields: {}, missingFields: {} };
        }
        const {
            serviceDate,
            initialVerificationLeakInspection: { inspectionDate: repairDate },
            verificationLeakInspection: { inspectionDate: followUpInspectionDate },
            selectedAsset: { disbursementDate }
        } = formState;
        const formattedServiceDate = getFormattedDate(serviceDate);
        const formatttedRepairDate = getFormattedDate(repairDate);
        const formattedDisbursementDate = getFormattedDate(disbursementDate);
        const invalidFields = { inspectionDate: {} };
        const nestedKey = "verificationLeakInspection";
        const requiredFieldsArray = requiredFieldsRef.current["FollowUpVerificationService"]
        const missingFields = getRequiredFieldsMissing(requiredFieldsArray, nestedKey);
        let errorsExist = getInitialErrorsExist({ missingFields, requiredFieldsArray, nestedKey });

        if (
            repairDate
            && followUpInspectionDate
            && moment(followUpInspectionDate).isBefore(repairDate, 'day')
        ) {
            invalidFields.inspectionDate = {
                errorExists: true,
                helperText: `Date of Follow Up Inspection must be on or after Repair Date (${formatttedRepairDate}) in Initial Verification Test section`
            };
            errorsExist = true;
        }

        if (moment(followUpInspectionDate).isBefore(serviceDate, 'day')) {
            invalidFields.inspectionDate = {
                errorExists: true,
                helperText: `Date of Follow Up Inspection cannot be before Service Date (${formattedServiceDate})`
            };
            errorsExist = true;
        }

        if (
            followUpInspectionDate
            && disbursementDate
            && moment(followUpInspectionDate).isAfter(disbursementDate, 'day')
        ) {
            invalidFields.inspectionDate = {
                errorExists: true,
                helperText: `Date of Follow Up Inspection cannot be after Shutdown Date (${formattedDisbursementDate})`
            };
            errorsExist = true;
        }

        return { errorsExist, invalidFields, missingFields };
    };

    const validateGasTransaction = () => {
        const {
            selectedAsset: {
                gasChargeCapacityLbs: assetMaxGasCapacity = null,
            } = {},
            serviceOrLeakRepairError = false,
        } = formState;
        const invalidFields = {};
        const requiredFieldsArray = requiredFieldsRef.current["GasTransaction"] || [];
        const missingFields = getRequiredFieldsMissing(requiredFieldsArray);
        let errorsExist = getInitialErrorsExist({ missingFields, requiredFieldsArray });
        const totalGasInstallAmount = getTotalGasAmount(formState.installs);
        const totalGasRecoverAmount = getTotalGasAmount(formState.recoveries);
        const convertedAssetMaxGasCapacity = getConvertedWeight(assetMaxGasCapacity);
        const installMaxExceeded = (!isRetroFit && totalGasInstallAmount > convertedAssetMaxGasCapacity);
        // Only enforce new-system capacity once it's known (avoids blocking on unset).
        const installNewMaxExceeded = (isRetroFit && newSystemCapacityKnown && totalGasInstallAmount > newSystemMaxCapacity);
        const recoverMaxExceeded = totalGasRecoverAmount > convertedAssetMaxGasCapacity;

        if (
            installMaxExceeded
            || installNewMaxExceeded
            || recoverMaxExceeded
            || serviceOrLeakRepairError
        ) {
            errorsExist = true;
        }

        return { errorsExist, invalidFields, missingFields };
    };

    // Post Shutdown Status is required for Shutdown/Mothball, so it must gate Complete.
    const validatePostShutdownStatus = () => {
        const requiredFieldsArray = requiredFieldsRef.current["PostShutdownStatus"] || [];
        const missingFields = getRequiredFieldsMissing(requiredFieldsArray);
        const errorsExist = getInitialErrorsExist({ missingFields, requiredFieldsArray });
        return { errorsExist, invalidFields: {}, missingFields };
    };

    const validateNewSystemDetails = () => {
        const { newMaterialTypeId, newOilType } = formState;
        const invalidFields = { newMaterialTypeId: false, newOilType: null };
        const requiredFieldsArray = requiredFieldsRef.current["NewSystemDetails"];
        const missingFields = getRequiredFieldsMissing(requiredFieldsArray);
        let errorsExist = getInitialErrorsExist({ missingFields, requiredFieldsArray });

        const materialTypeValid = newMaterialTypeId && dropdownOptions.materialTypes.some(mt => mt.id === newMaterialTypeId);
        if (!materialTypeValid) {
            invalidFields.newMaterialTypeId = true;
        }

        if (!newOilType) {
            invalidFields.newOilType = true;
        }

        return { errorsExist, invalidFields, missingFields };
    };

    const validateVerificationTests = () => {
        const { verificationLeakDetectionMethodId, chargeCapacitySourceTypeId } = formState;
        const invalidFields = {
            verificationLeakDetectionMethodId: false,
            chargeCapacitySourceTypeId: null
        };
        const requiredFieldsArray = requiredFieldsRef.current["VerificationTests"];
        const missingFields = getRequiredFieldsMissing(requiredFieldsArray);
        let errorsExist = getInitialErrorsExist({ missingFields, requiredFieldsArray });

        if (!verificationLeakDetectionMethodId) {
            invalidFields.verificationLeakDetectionMethodId = true;
        }

        if (!chargeCapacitySourceTypeId) {
            invalidFields.chargeCapacitySourceTypeId = true;
        }

        return { errorsExist, invalidFields, missingFields };
    };

    const getSliceEndIndex = (stepIndex) => {
        const { maxViewedStepIndex } = formState;

        if (stepIndex > maxViewedStepIndex) {
            return stepIndex;
        }

        // User going backward - must validate the step they are leaving
        if (!isEditing && stepIndex < maxViewedStepIndex || stepIndex === maxViewedStepIndex) {
            return maxViewedStepIndex + 1;
        }

        return maxViewedStepIndex;
    };

    // This function checks for missing required fields..
    // ..as well as any invalid fields on all all steps
    const validateAllSteps = ({ stepIndex = null, isSavingForLater = false }) => {
        const sliceEndIndex = getSliceEndIndex(stepIndex);
        let missingFieldsObject = {};
        let fieldsWithBadData = {};

        // these steps require date fields to be validated
        const stepValidationFunctions = {
            EnterService: validateEnterService,
            RepairDetails: validateRepairDetails,
            RepairNotes: validateRepairNotes,
            InitialVerificationTest: validateInitialVerificationTest,
            FollowUpVerificationService: validateFollowUpVerificationService,
            GasTransaction: validateGasTransaction,
            PostShutdownStatus: validatePostShutdownStatus,
            NewSystemDetails: validateNewSystemDetails,
            VerificationTests: validateVerificationTests,
        };
    
        let allSteps = serviceEventSteps
            .slice(0, sliceEndIndex)
            .map(s => s.props.id)
            .filter(step => requiredFieldsRef.current[step]);

        const stepsWithErrors = allSteps.map((step) => {
            const validationFunction = stepValidationFunctions[step];
            // if certain step does not have a valididation function such as RepairNotes, return {} as a default
            const {
                errorsExist = false,
                invalidFields = {},
                missingFields = {},
            } = validationFunction && validationFunction(isSavingForLater) || {};

            // Missing required fields
            missingFieldsObject = {
                ...missingFieldsObject,
                ...missingFields
            };

            // Invalid fields (dates)
            fieldsWithBadData = {
                ...fieldsWithBadData,
                ...invalidFields
            };

            return errorsExist;
        });

        // console.log('all missing fields', missingFieldsObject)
        
        return {
            missingFieldsObject,
            stepsWithErrors,
            fieldsWithBadData
        };
    };

    const validateAndSubmit = async () => {
        const { stepsWithErrors } = validateAllSteps({});
        const { workItemStatusId } = formState;
        const workItemCompleted = workItemStatusId === Enums.WorkItemStatusTypes.WorkComplete;

        if (stepsWithErrors.includes(true)) {
            setServiceEventStepErrors(stepsWithErrors);
            let message = "One or more data validations has failed. Please correct the necessary field(s) for each section highlighted red";

            if (!workItemCompleted) {
                message = `${message}, or select Save For Later.`;
            }

            return toast.error(message, { duration: 5000 });
        }

        if ( formState.verificationLeakInspection.wasLeakFound === false && 
             formState.initialLeakInspection.wasLeakFound === false &&
             formState.initialVerificationLeakInspection.wasLeakFound === false  &&
             formState.coolingApplianceStatusId === Enums.SE.CoolingApplianceStatus.NormalOperation &&
             isEditing === false) {
            return toast.error('Asset cannot be in Normal Operation if no repair was performed', { duration: 6000 });
        }    
        setSaving(true);
        try {
            const { newServiceEventID, success } = await saveServiceEvent();

            if (success) {
                setNewServiceEventId(newServiceEventID);

                if (isEditing) {
                    toast.success("The service event has been successfully edited.", { duration: 6000 });
                    return navigate.goBack(`/ServiceEvent/${newServiceEventId}`);
                } else {
                    return setFormState(prev => ({ ...prev, finalModalOpen: true }));
                }
            }

            return null;
        } finally {
            setSaving(false);
        }
    };

    const handleMainButtonClick = () => {
        if (finalStep) {
            return validateAndSubmit();
        }

        return handleStepChange(activeStep + 1);
    };

    const handleStepChange = (stepIndex, bypassGasDirtyCheck = false) => {
        const { maxViewedStepIndex } = formState;
        hotjar.stateChange(document.URL + '#' + serviceEventSteps[activeStep]);

        // If leaving the Gas Transaction step with unsaved entry-form data, confirm before navigating.
        const leavingGasTransaction = (
            serviceEventSteps[activeStep]?.props?.id === 'GasTransaction'
            && stepIndex !== activeStep
        );
        if (!bypassGasDirtyCheck && leavingGasTransaction && gasTransactionDirtyRef.current) {
            setPendingStepIndex(stepIndex);
            setDiscardGasModalOpen(true);
            return null;
        }

        // Skip over any skipped steps in the direction of travel so the user lands on a navigable step.
        const direction = stepIndex > activeStep ? 1 : stepIndex < activeStep ? -1 : 0;
        if (direction !== 0 && skippedStepIds.length > 0) {
            let target = stepIndex;
            while (
                target >= 0
                && target < serviceEventSteps.length
                && skippedStepIds.includes(serviceEventSteps[target]?.props?.id)
            ) {
                target += direction;
            }
            if (target >= 0 && target < serviceEventSteps.length) {
                stepIndex = target;
            }
        }

        if (gasInstallationRequired && noGasInstallationData && stepIndex > activeStep) return null;
 
        const {
            missingFieldsObject,
            stepsWithErrors,
            fieldsWithBadData,
        } = validateAllSteps({ stepIndex });
        const {
            assetId,
            primaryTechnicianId,
            serviceDate,
            workItemTypeId,
        } = missingFieldsObject;

        // User is on Enter Service screen and minimum required fields are missing.
        // Do not let user proceed forward.
        if (userOnFirstStep && (assetId || primaryTechnicianId || serviceDate || workItemTypeId)) {
            setServiceEventStepErrors(stepsWithErrors);
            return setRequiredFieldsMissing(missingFieldsObject);
        }

        // maxViewedStepIndex indicates the farthest step user has reached
        if (!isEditing && stepIndex > maxViewedStepIndex) {
            setFormState((prev) => ({
                ...prev,
                maxViewedStepIndex: stepIndex
            }));
        }

        setServiceEventStepErrors(stepsWithErrors);
        setRequiredFieldsMissing(missingFieldsObject);
        setFieldsWithErrors(fieldsWithBadData);
        return setActiveStep(stepIndex);
    };

    // Discard: clear the flag and navigate. The unsaved entry lives in GasTransaction's local
    // state, so leaving (unmount) drops it; saved table rows in formState are kept.
    const confirmDiscardGasTransfer = () => {
        setDiscardGasModalOpen(false);
        gasTransactionDirtyRef.current = false;
        const target = pendingStepIndex;
        setPendingStepIndex(null);
        if (target != null) handleStepChange(target, true);
    };

    const cancelDiscardGasTransfer = () => {
        setDiscardGasModalOpen(false);
        setPendingStepIndex(null);
    };

    const saveForLater = async () => {
        const { maxViewedStepIndex } = formState;
        let stepIndex = maxViewedStepIndex || null;

        if (serviceEventSteps[activeStep].props.id === "EnterService") {
            stepIndex = 0;
        }

        const {
            missingFieldsObject,
            stepsWithErrors,
            fieldsWithBadData,
        } = validateAllSteps({ stepIndex });

        const { primaryTechnicianId } = missingFieldsObject;

        // primaryTechnicianId is missing
        if (primaryTechnicianId) {
            setServiceEventStepErrors(stepsWithErrors);
            setRequiredFieldsMissing(missingFieldsObject);
            return setFieldsWithErrors(fieldsWithBadData);
        }

        if (renderSaveForLaterModal) return setFormState(prev => ({ ...prev, saveForLaterModalOpen: true }));

        setSaving(true);
        try {
            const { newServiceEventID, success } = await saveServiceEvent("saveForLater");

            console.log('success after createServiceEvent', success);

            if (success) {
                setNewServiceEventId(newServiceEventID);
                return handleSuccessSaveForLater(newServiceEventID);
            }

            return null;
        } finally {
            setSaving(false);
        }
    };

    const handleExit = () => {
        // Create - asset selected (minimum required field)
        if (!isEditing && formState.assetId) return openExitModal();
        
        // Edit - Field changed or removed
        const { selectedAsset, ...rest } = formState;
        if (isEditing && isDirty(rest)) return openExitModal();

        navigate.goBack(`/WorkOrder/${workOrderID}`, state.from);
    };

    const determineButtonText = () => {
        if (serviceEventSteps[activeStep].props.id === "EnterService") {
            return "Proceed";
        }
        if (finalStep) {
            return TranslateW("serviceEventView.showSaveCancel.complete");
        }

        let nextStepIndex = activeStep + 1;
        while (
            nextStepIndex < serviceEventSteps.length
            && skippedStepIds.includes(serviceEventSteps[nextStepIndex]?.props?.id)
        ) {
            nextStepIndex += 1;
        }

        const nextStepId = serviceEventSteps[nextStepIndex]?.props?.id;
        if (!nextStepId) return TranslateW("Next");

        return `Next: ${TranslateW(nextStepId)}`;
    };

    // The primary (Next/Complete) button re-validates live so it disables the moment a required
    // field is cleared. On the Gas Transaction step that's the live step check; on the final
    // (Complete) step we re-check every viewed step, so clearing e.g. "Was Appropriate Vacuum
    // Pulled?" still disables Complete after navigating past that step.
    const onGasTransactionStep = serviceEventSteps[activeStep].props.id === "GasTransaction";
    const gasTransactionHasErrors = onGasTransactionStep && validateGasTransaction().errorsExist;
    const finalStepHasErrors = finalStep
        && !!requiredFieldsRef.current
        && validateAllSteps({}).stepsWithErrors.includes(true);

    // Service Action is a required Enter Service field for some SE types (e.g. Shutdown/Mothball).
    // Block advancing past Enter Service until it's set, but only when it's actually required.
    const enterServiceActionMissing = (
        serviceEventSteps[activeStep].props.id === "EnterService"
        && (requiredFieldsRef.current?.["EnterService"] || []).includes("serviceActionId")
        && badValuesArray.includes(formState.serviceActionId)
    );

    const primaryActionDisabled = (
        serviceEventSteps[activeStep].props.id === "EnterService"
            ? !enterServiceReady
            : nextDisabled
    ) || gasTransactionHasErrors || finalStepHasErrors || enterServiceActionMissing;

    const saveForLaterDisabled = (
        saving
        || !enterServiceReady
        || nextDisabled
    );

    const saveForLaterColor = saveForLaterDisabled ? inactiveStatusColor : trakrefBlue;

    const openExitModal = () => setFormState(prev => ({ ...prev, exitModalOpen: true }));

    const handleAssetSelect = async ({
        assetId,
        assetList = dropdownOptions.assets,
        workItemTypes = dropdownOptions.savedWorkItemTypes,
        technicianList = dropdownOptions.technicians,
        primaryTechnicianId = '',
        subsystemId = '',
    }) => {
        if (!isEditing && !state.serviceEventData) setFormState(prev => ({ ...prev, workItemTypeId: "" }));
        if (serviceEventSteps.length > 1) {
            setServiceEventSteps([Translate("EnterService")]);
        }
        
        // User is clearing out selected asset
        if (!assetId) {
            return setFormState((prev) => ({
                ...prev,
                assetId: null,
                subsystemId: null,
                assetMaterialTypeId: null,
                assetLocationId: null,
                coolingApplianceStatusId: null,
                assetStatusId: null,
                assetDetails: null,
                selectedAsset: null
            }));
        }

        
        const selectedAsset = assetList.find(a => a.id === assetId);
        const {
            coolingApplianceStatusId = null,
            materialTypeId = null,
            locationId = null,
            assetStatusId = null,
            name = '',
            gasChargeCapacityLbs = null,
            currentGasWeightLbs = null,
            materialTypeName = null,
            coolingApplianceStatusName = '',
        } = selectedAsset;
        const assetUnderRepair = coolingApplianceStatusId === Enums.SE.CoolingApplianceStatus.UnderRepair;
        let filteredWorkItemTypes = workItemTypes;

        if (!isEditing) {
            filteredWorkItemTypes = determineServiceOptions(
                assetUnderRepair,
                selectedAsset,
                workItemTypes,
                serviceEventId
            );
        }

        // DELETE THIS LINE BEFORE GOING LIVE
        filteredWorkItemTypes = filteredWorkItemTypes.filter(type => enabledServiceEventTypes.includes(type.id));
        // ----------------------------------------------

        const assetDetails = {
            name,
            maxGasCapacity: gasChargeCapacityLbs,
            currentGasWeightLbs,
            materialTypeName,
            coolingApplianceStatusName,
        };
        setFormState((prev) => ({
            ...prev,
            assetId,
            subsystemId,
            assetMaterialTypeId: materialTypeId,
            assetLocationId: locationId,
            coolingApplianceStatusId,
            assetStatusId,
            assetDetails,
            selectedAsset
        }));
        let finalTechniciansList = filterTechniciansForService(
            assetDetails,
            technicianList,
            workOrderState === 'CA'
        );

        if (isEditing && primaryTechnicianId && !finalTechniciansList.find(t => t.id === primaryTechnicianId)) {
            const primaryTechnician = technicianList.find(t => t.id === primaryTechnicianId);
            finalTechniciansList.push(primaryTechnician);
            finalTechniciansList = finalTechniciansList.sort((a, b) => a.lastName.localeCompare(b.lastName));
        }

        // Clear primaryTechnicianId from state
        // this field will ONLY ever be empty if editing a service event..
        // ..created via the API
        if (!primaryTechnicianId) {
            setFormState(prev => ({ ...prev, primaryTechnicianId: "" }));
        }
        
        // Only supporting LeakInspection & ServiceOrLeakRepair for mobile
        if (isMobile) {
            filteredWorkItemTypes = filteredWorkItemTypes.filter(x =>
                [
                    Enums.ServiceEvents.LeakInspection,
                    Enums.ServiceEvents.ServiceOrLeakRepair,
                    Enums.ServiceEvents.Retrofit,
                ].includes(x.id)
            );
        }

        setDropdownOptions((prev) => ({
            ...prev,
            filteredTechs: finalTechniciansList,
            workItemTypes: filteredWorkItemTypes,
        }));
        await fetchAfterServiceStatusOptions(assetStatusId);
        await fetchVitalStatsTable(assetId);
        await fetchRecentLeaks(assetId);

    };

    const fetchVitalStatInputFields = async () => {
        const assetId = formState.assetId;
        const data = await fetch(Routes.VitalStat.GetInputFields(assetId));
        const inputFields = await data.json();
        const values = inputFields.map(field => ({
            vitalStatV3Id: field.id,
            assetId,
            value: null,
            notes: null
        }));
        return setVitalStatState({ inputFields, values });
    };

    const fetchVitalStatsTable = async (assetId) => {
        setVitalStatState({ loading: true });
        const response = await fetch(Routes.VitalStat.GetTable(assetId));
        const data = await response.json();
        const { tableValues = [] } = data;
        // console.log('what did we get back', data);
        setVitalStatState({ tableValues, loading: false });
    };

    const fetchRecentLeaks = async (assetId) => {
        setRecentLeaksData(prev => ({ ...prev, loading: true }));
        try {
            const response = await fetch(Routes.ServiceEvent.GetRecentLeaks(assetId));
            const data = await response.json();
            setRecentLeaksData({ leaks: data.leaks, totalCount: data.totalCount, loading: false });
        } catch {
            setRecentLeaksData({ leaks: [], totalCount: 0, loading: false });
        }
    };

    const handleOpenVitalStats = () => {
        fetchVitalStatInputFields();
        return setVitalStatsOpen(true);
    };

    const handleSuccessVitalStat = () => {
        toast.success('Vital Stat successfully created', { duration: 5000 });
        return window.scrollTo(0, 0);
    };

    const determineSaveSuccessText = (serviceEventID) => (
        <span>
            The Service Event #{serviceEventID} has been successfully saved for later.
            <span style={{ fontWeight: '100' }}>
                <span
                    style={{
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        marginLeft: "8px"
                    }}
                    onClick={() => {
                        push(`/ServiceEvent/${serviceEventID}`)
                        toast.dismiss();
                    }}
                >
                    VIEW SERVICE EVENT
                </span>
            </span>
        </span>
    );

    const handleSuccessSaveForLater = (serviceEventID) => {
        toast.success(determineSaveSuccessText(serviceEventID), { duration: 5000 });
        setFormState(prev => ({ ...prev, saveForLaterModalOpen: false }));
        return push(`/WorkOrder/${workOrderID}`);
    };

    const handleShowAgainSaveForLater = () => {
        const showAgain = formState.saveForLaterShowAgain;
        localStorage.setItem("saveForLaterShowAgain", showAgain);
        return setFormState(prev => ({ ...prev, saveForLaterShowAgain: !showAgain }));
    };

    const validateVitalStatRequiredFields = () => {
        const errorObj = {};
        let errorsExists = false;
        let warning = false;
        const allVitalStatValues = vitalStatData.values.map(vs => vs.value);
        if (!vitalStatData.technicianUserId) {
            errorObj.technicianUserId = true;
            errorsExists = true;
        }

        // at least 1 vital value must exist in order to sumbit
        if (allVitalStatValues.every(value => value === null || value === "")) {
            warning = true;
            errorsExists = true;
        }

        setVitalStatState({ errors: errorObj, warning });
        return errorsExists;
    };

    const submitVitalStat = async () => {
        const errorExists = validateVitalStatRequiredFields();

        if (errorExists) return null;

        // only submit vital stats that have value
        const finalData = vitalStatData.values.filter(vs => vs.value);
        const assetId = formState.assetId;
        console.log('vital stat values before save', finalData);

        const response = await fetch(Routes.VitalStat.Create(), {
            method: "POST",
            headers: { ...postRequestHeaders },
            body: JSON.stringify(finalData)
        });
        const success = response.status === 200;
        console.log('success', success);

        if (success) {
            setVitalStatsOpen(false);
            fetchVitalStatsTable(assetId);
            // reset vital stat state
            setVitalStatData({ ...initialVitalStatState });
            return handleSuccessVitalStat();
        }
    };
    const getContainerWidth = () => {
        return '100%';
    };

    const {
        coolingApplianceStatusName,
        materialTypeName,
        maxGasCapacity,
        name: assetName,
    } = formState.assetDetails || {};
    const workOrderTitle = formState.workOrderNumber || (workOrderID ? `WO-${workOrderID}` : "");
    const assetSummaryItems = [
        assetName && `Asset: ${assetName}`,
        coolingApplianceStatusName && `Status: ${coolingApplianceStatusName}`,
        materialTypeName && `Material Type: ${materialTypeName}`,
        maxGasCapacity != null && `Gas Capacity: ${renderWeight(maxGasCapacity)}`,
    ].filter(Boolean);
    const renderStepperHeader = activeStep > 0;

    const renderSaveForLaterAction = (sx = {}) => (
        <Button
            variant="text"
            disabled={saveForLaterDisabled}
            onClick={saveForLater}
            startIcon={<SaveIcon sx={{ fontSize: 18 }} />}
            sx={{
                minWidth: "unset",
                minHeight: "auto",
                padding: "6px 8px",
                borderRadius: "4px",
                textTransform: "none",
                color: saveForLaterColor,
                fontSize: "14px",
                fontFamily: trakrefFontFamily,
                fontWeight: 400,
                lineHeight: 1,
                backgroundColor: "transparent",
                "&:hover": {
                    backgroundColor: Grey6,
                },
                "& .MuiButton-startIcon": {
                    marginRight: "6px",
                    marginLeft: 0,
                },
                "& .MuiButton-startIcon svg": {
                    color: saveForLaterColor,
                    fill: saveForLaterColor,
                },
                "&.Mui-disabled": {
                    color: saveForLaterColor,
                    WebkitTextFillColor: saveForLaterColor,
                    cursor: "not-allowed",
                    backgroundColor: "transparent",
                },
                ...sx,
            }}
        >
            {TranslateW("serviceEventView.showSaveCancel.save-for-later")}
        </Button>
    );

    if (loading || loading2) {
        return <LoadingBar />;
    }

    if (hasError404) {
        return <Error404 />;
    }

    return (
        <>
            <Grid container item sx={{ ...mobileBreakpoints }}>
                <BreadCrumbs
                    path={breadCrumb.getSortedBreadCrumbs()}
                />
            </Grid>
            <Grid
                container
                direction="row"
                alignItems="center"
                sx={{
                    maxWidth: getContainerWidth(),
                    padding: { xs: "2%", md: 0 },
                    borderBottom: renderStepperHeader ? `1px solid ${chromeDividerColor}` : "none",
                    minHeight: renderStepperHeader ? 74 : "auto",
                }}
            >
                <Grid item sx={{ marginRight: "10px" }}>
                    <IconButton
                        aria-label={renderStepperHeader ? "back to enter service" : "close"}
                        onClick={renderStepperHeader ? () => handleStepChange(0) : handleExit}
                        sx={{ color: Grey1 }}
                    >
                        {renderStepperHeader ? <ArrowBackIcon /> : <CloseIcon />}
                    </IconButton>
                </Grid>
                <Grid item xs={10} md={6}>
                    {renderStepperHeader ? (
                        <Box>
                            <Typography
                                sx={{
                                    color: Grey1,
                                    fontFamily: trakrefFontFamily,
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    lineHeight: 1.2,
                                }}
                            >
                                {workOrderTitle}
                            </Typography>
                            {assetSummaryItems.length > 0 && (
                                <Typography
                                    sx={{
                                        color: chromeMutedTextColor,
                                        fontFamily: trakrefFontFamily,
                                        fontSize: "12px",
                                        lineHeight: 1.35,
                                        marginTop: "4px",
                                    }}
                                >
                                    {assetSummaryItems.join(" · ")}
                                </Typography>
                            )}
                        </Box>
                    ) : (
                        <PageTitleWithToolTip
                            pageTitle={pageHeader}
                            toolTipText={isEditing ? "" : TranslateW("CreateServiceEventTooltipText")}
                        />
                    )}
                </Grid>
                <Grid
                    item
                    sx={{
                        marginLeft: "auto",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                    {renderStepperHeader && (
                        <Box
                            sx={{
                                backgroundColor: chromeInfoBackground,
                                borderRadius: "16px",
                                color: trakrefBlue,
                                display: { xs: "none", md: "inline-flex" },
                                fontFamily: trakrefFontFamily,
                                fontSize: "12px",
                                lineHeight: 1,
                                marginRight: renderSaveForLaterButton ? 2 : 0,
                                padding: "7px 12px",
                                whiteSpace: "nowrap",
                            }}
                        >
                            In Progress
                        </Box>
                    )}
                    {saving && (
                        <LoadingButton
                            text={TranslateW("servicerInstancesMainTab.saving")}
                            loadingWheelSize={24}
                            color={trakrefBlue}
                        />
                    )}
                    {renderSaveForLaterButton && (
                        renderSaveForLaterAction({ display: { xs: "none", md: "inline-flex" } })
                    )}
                </Grid>
            </Grid>
            <Box
                sx={{
                    maxWidth: getContainerWidth(),
                    px: { xs: 2, sm: 2.5, md: 0 },
                    mt: { xs: 2, md: 2.5 },
                }}
            >
                {shouldRenderStepper && (
                    <Stepper
                        activeStep={visibleActiveStep}
                        steps={visibleStepperSteps}
                        stepCompleted={visibleStepperCompleted}
                        skippedStepIds={skippedStepIds}
                        onStepChange={(stepIndex) => handleStepChange(stepIndex + 1)}
                        sx={{ marginTop: 3, marginBottom: 3 }}
                    />
                )}
                {serviceEventSteps[activeStep].props.id === "EnterService" && (
                    <EnterService
                        loading={loading}
                        dropdownOptions={dropdownOptions}
                        changeServiceType={changeServiceType}
                        formState={formState}
                        setGlobalState={setGlobalState}
                        requiredFieldsMissing={requiredFieldsMissing}
                        fieldsWithErrors={fieldsWithErrors}
                        warning={warning}
                        setWarning={setWarning}
                        isEditing={isEditing}
                        handleAssetSelect={handleAssetSelect}
                        shouldFetchCylinders={shouldFetchCylinders}
                        fetchCylindersForAsset={fetchCylindersForAsset}
                        renderServiceActionField={renderServiceActionField}
                        push={push}
                        handleOpenVitalStats={handleOpenVitalStats}
                        vitalStatData={vitalStatData}
                        recentLeaksData={recentLeaksData}
                    />
                )}

                {serviceEventSteps[activeStep].props.id === 'RepairDetails' && (
                    <RepairDetails
                        formState={formState}
                        dropdownOptions={dropdownOptions}
                        setGlobalState={setGlobalState}
                        setRequiredFields={setRequiredFields}
                        requiredFieldsMissing={requiredFieldsMissing}
                        serviceEventSteps={serviceEventSteps}
                        setServiceEventSteps={(steps) => setServiceEventSteps(normalizeLegacyGasSteps(steps))}
                        oldRequiredFields={oldRequiredFields}
                        fieldsWithErrors={fieldsWithErrors}
                        requiredFieldsRef={requiredFieldsRef}
                    />
                )}

                {serviceEventSteps[activeStep].props.id === 'ProblemResolution' && (
                    <ProblemResolution
                        formState={formState}
                        setGlobalState={setGlobalState}
                        dropdownOptions={dropdownOptions}
                        requiredFieldsMissing={requiredFieldsMissing}
                        oldRequiredFields={oldRequiredFields}
                        setRequiredFields={setRequiredFields}
                        requiredFieldsRef={requiredFieldsRef}
                    />
                )}

                {serviceEventSteps[activeStep].props.id === 'PostShutdownStatus' && (
                    <PostShutDownStatus
                        formState={formState}
                        setGlobalState={setGlobalState}
                        postShutDownStatuses={dropdownOptions.coolingApplianceStatuses.filter(i => !!i.includeInShutdown)}
                    />
                )}

                {serviceEventSteps[activeStep].props.id === 'InitialVerificationTest' && (
                    <InitialVertificationTest
                        formState={formState}
                        setGlobalState={setGlobalState}
                        dropdownOptions={dropdownOptions}
                        requiredFieldsMissing={requiredFieldsMissing}
                        setRequiredFieldsMissing={setRequiredFieldsMissing}
                        serviceEventSteps={serviceEventSteps}
                        setServiceEventSteps={(steps) => setServiceEventSteps(normalizeLegacyGasSteps(steps))}
                        setRequiredFields={setRequiredFields}
                        fieldsWithErrors={fieldsWithErrors}
                        requiredFieldsRef={requiredFieldsRef}
                        skippedStepIds={skippedStepIds}
                        setSkippedStepIds={setSkippedStepIds}
                    />
                )}

                {serviceEventSteps[activeStep].props.id === 'RepairNotes' && (
                    <RepairNotes
                        formState={formState}
                        setGlobalState={setGlobalState}
                        dropdownOptions={dropdownOptions}
                        requiredFieldsMissing={requiredFieldsMissing}
                    />
                )}

                {serviceEventSteps[activeStep].props.id === 'NewSystemDetails' && (
                    <NewSystemDetails
                        formState={formState}
                        setGlobalState={setGlobalState}
                        dropdownOptions={dropdownOptions}
                        setDropdownOptions={setDropdownOptions}
                        requiredFieldsMissing={requiredFieldsMissing}
                        isRetrofit={isRetroFit}
                    />
                )}

                {serviceEventSteps[activeStep].props.id === 'GasTransaction' && (
                    <GasTransaction
                        formState={formState}
                        setGlobalState={setGlobalState}
                        dropdownOptions={dropdownOptions}
                        setDropdownOptions={setDropdownOptions}
                        isRetroFit={isRetroFit}
                        requiredFieldsMissing={requiredFieldsMissing}
                        setRequiredFields={setRequiredFields}
                        oldRequiredFields={oldRequiredFields}
                        fieldsWithErrors={fieldsWithErrors}
                        requiredFieldsRef={requiredFieldsRef}
                        gasTransactionDirtyRef={gasTransactionDirtyRef}
                    />
                )}

                {serviceEventSteps[activeStep].props.id === 'FollowUpVerificationService' && (
                    <FollowUpVerificationTest
                        formState={formState}
                        setGlobalState={setGlobalState}
                        dropdownOptions={dropdownOptions}
                        requiredFieldsMissing={requiredFieldsMissing}
                        setRequiredFields={setRequiredFields}
                        fieldsWithErrors={fieldsWithErrors}
                        requiredFieldsRef={requiredFieldsRef}
                    />
                )}

                {serviceEventSteps[activeStep].props.id === 'VerificationTests' && (
                    <VerificationTests
                        formState={formState}
                        setGlobalState={setGlobalState}
                        dropdownOptions={dropdownOptions}
                        requiredFieldsMissing={requiredFieldsMissing}
                    />
                )}

                {serviceEventSteps[activeStep].props.id === 'Completion' && (
                    // Scope (ADO #14716, AC #11): the Completion REVIEW page is for
                    // Service or Leak Repair only. All other SE types keep the existing
                    // Complete step (Labor Hours / GL Code) unchanged until adopted in
                    // future stories.
                    formState.workItemTypeId === Enums.SE.WorkItemType.ServiceOrLeakRepair ? (
                        <Completion
                            formState={formState}
                            setGlobalState={setGlobalState}
                            dropdownOptions={dropdownOptions}
                            isEditing={isEditing}
                            isAdmin={isAdmin}
                            serviceEventSteps={serviceEventSteps}
                            skippedStepIds={skippedStepIds}
                            requiredFieldsRef={requiredFieldsRef}
                            missingFieldsObject={validateAllSteps({}).missingFieldsObject}
                            onCardClick={(stepId) => {
                                const stepIndex = serviceEventSteps.findIndex(s => s.props.id === stepId);
                                if (stepIndex >= 0) handleStepChange(stepIndex);
                            }}
                        />
                    ) : (
                        <LaborHours
                            formState={formState}
                            setGlobalState={setGlobalState}
                            dropdownOptions={dropdownOptions}
                            isEditing={isEditing}
                            isAdmin={isAdmin}
                        />
                    )
                )}

                <Grid
                    container
                    sx={{
                        alignItems: "center",
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        display: "flex",
                        gap: "12px",
                        justifyContent: "flex-end",
                        marginTop: 3,
                        width: "100%",
                        padding: { xs: "14px 16px", md: "16px 28px" },
                        flexWrap: "wrap",
                    }}
                >
                    {renderSaveForLaterButton && (
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: { xs: "flex", md: "none" },
                                justifyContent: "flex-end",
                            }}
                        >
                            {renderSaveForLaterAction()}
                        </Grid>
                    )}
                    {activeStep > 0 && (
                        <Grid item sx={{ flex: { xs: "1 1 0", sm: "0 0 auto" } }}>
                            <SecondaryButton
                                useLargeButton
                                buttonText={"Back"}
                                onClick={() => handleStepChange(activeStep - 1)}
                                disabled={saving}
                                sx={{
                                    height: 42,
                                    minWidth: 150,
                                    px: 2,
                                    width: { xs: "100%", sm: "auto" },
                                    "& .MuiTypography-root": {
                                        fontSize: "14px",
                                        letterSpacing: 0,
                                        textTransform: "none",
                                    },
                                    "&.MuiButton-root": {
                                        borderColor: chromeDividerColor,
                                        borderRadius: "4px",
                                        color: Grey1,
                                    },
                                }}
                            />
                        </Grid>
                    )}
                    <Grid item sx={{ flex: { xs: "1 1 0", sm: "0 0 auto" } }}>
                        <PrimaryButton
                            useLargeButton
                            buttonText={determineButtonText()}
                            onClick={() => handleMainButtonClick()}
                            disabled={primaryActionDisabled}
                            sx={{
                                height: 42,
                                minWidth: { xs: 0, sm: 232 },
                                px: 2,
                                width: { xs: "100%", sm: "auto" },
                                "& .MuiTypography-root": {
                                    fontSize: "14px",
                                    letterSpacing: 0,
                                    textTransform: "none",
                                },
                                "&.MuiButton-root": {
                                    backgroundColor: trakrefBlue,
                                    borderRadius: "4px",
                                    letterSpacing: 0,
                                    textTransform: "none",
                                },
                                "&.Mui-disabled": {
                                    backgroundColor: Grey6,
                                    color: Grey3,
                                    cursor: "not-allowed",
                                    pointerEvents: "auto",
                                },
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>

            <Drawer
                anchor='right'
                open={vitalStatsOpen}
                onClose={() => setVitalStatsOpen(false)}
            >
                <RecordVitalStats
                    dropdownOptions={dropdownOptions}
                    fetchVitalStatInputFields={fetchVitalStatInputFields}
                    vitalStatData={vitalStatData}
                    setVitalStatState={setVitalStatState}
                    closeDrawer={() => setVitalStatsOpen(false)}
                    submitVitalStat={submitVitalStat}
                />
            </Drawer>

            <CreationSuccessModal
                open={formState.finalModalOpen}
                close={() => {
                    setGlobalState("finalModalOpen", false);
                    push(`/WorkOrder/${workOrderID}`);
                }}
            >
                <Grid container>
                    <Grid item xs={12} lg={12} align='center'>
                        <img
                            style={{ paddingTop: '1%', paddingBottom: '5%' }}
                            src={Rocket}
                            width="226px"
                            height="193px"
                            alt={`Service Event successfully ${isEditing ? "edited" : "created"}.`}
                        />
                    </Grid>
                    <Grid item xs={12} lg={12} align='center'>
                        <Typography
                            variant="h5"
                            sx={{ '&.MuiTypography-root': { fontFamily: trakrefFontFamily } }}
                            style={{ marginBottom: '6%', color: Black, fontSize: '22px' }}
                            align='center'
                        >
                            Service Event successfully {isEditing ? "edited" : "created"}.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} lg={12} align='center' marginBottom={2}>
                        <PrimaryButton
                            useLargeButton
                            width={70}
                            buttonText='VIEW WORK ORDER'
                            onClick={() => push(`/WorkOrder/${workOrderID}`)}
                        />
                    </Grid>
                    <Grid item xs={12} lg={12} align='center' marginBottom={2}>
                        <SecondaryButton
                            useLargeButton
                            width={70}
                            onClick={() => window.location.reload()}
                            buttonText='Create New Service Event'
                        />
                    </Grid>
                </Grid>
            </CreationSuccessModal>

            <ExitConfirmationModal
                isEditing={isEditing}
                open={formState.exitModalOpen}
                close={() => setFormState(prev => ({ ...prev, exitModalOpen: false }))}
                leaveOnClick={() => {
                    if (isEditing) {
                        return navigate.goBack(`/ServiceEvent/${serviceEventId}`, state.from);
                    }

                    navigate.goBack(`/WorkOrder/${workOrderID}`, state.from);
                }}
                stayOnClick={() => setFormState(prev => ({ ...prev, exitModalOpen: false }))}
            />

            <CommonModal open={discardGasModalOpen} close={cancelDiscardGasTransfer} bottom={20}>
                <Grid container>
                    <Grid item xs={12} align='center' sx={{ margin: '6% 0% 8%' }}>
                        <Typography
                            variant="h6"
                            sx={{ '&.MuiTypography-root': { fontFamily: trakrefFontFamily } }}
                            align='center'
                        >
                            {TranslateW('gasTransaction.unsaved-discard-title') || 'You have unsaved gas transfer data. Discard?'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} align='center' mb={2}>
                        <PrimaryButton
                            useLargeButton
                            fullWidth
                            buttonText={TranslateW('gasTransaction.discard') || 'Discard'}
                            onClick={confirmDiscardGasTransfer}
                            width={80}
                        />
                    </Grid>
                    <Grid item xs={12} align='center' mb={3}>
                        <SecondaryButton
                            useLargeButton
                            fullWidth
                            buttonText={TranslateW('gasTransaction.keep-editing') || 'Keep Editing'}
                            onClick={cancelDiscardGasTransfer}
                            width={80}
                        />
                    </Grid>
                </Grid>
            </CommonModal>

            <SaveForLaterModal
                header={TranslateW("ServiceEventSaveForLaterModalHeader")}
                open={formState.saveForLaterModalOpen}
                close={() => {
                    setFormState(prev => ({ ...prev, saveForLaterModalOpen: false }))
                }}
            >
                <Grid container>
                    <Grid item xs={12} align='center' sx={{ padding: '0% 4%' }}>
                        <Typography
                            variant="h5"
                            sx={{
                                '&.MuiTypography-root': {
                                    fontFamily: trakrefFontFamily,
                                    fontSize: '.875rem',
                                    lineHeight: '1.313rem',
                                }
                            }}
                            style={{ marginBottom: '6%', color: Grey3 }}
                            align='center'
                        >
                            Using the 'Save For Later' option does not finalize the service event;
                            it simply saves your progress without recording any material transfers or related activities.
                            As a result, the service event remains in an incomplete status until it is fully completed.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} align='center'>
                        <PrimaryButton
                            useLargeButton
                            width={53}
                            buttonText='Save For Later'
                            onClick={saveForLater}
                            disabled={saving}
                        />
                    </Grid>
                    <Grid item xs={6} mt={1} align='center' sx={{ marginLeft: '15%' }}>
                        <CheckBox
                            label={`Don't show this again`}
                            labelPlacement="end"
                            disabled={saving}
                            checked={formState.saveForLaterShowAgain}
                            onChange={handleShowAgainSaveForLater}
                            labelStyle={{
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '.788rem',
                                    fontFamily: trakrefFontFamily,
                                    color: '#000000'
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </SaveForLaterModal>
        </>
    );
};

export default withRouter(AddOrEditServiceEvent);
